import React, { FC } from "react";
import { isNil } from "lodash";

import { BarChart } from "./BarChart";
import { LineChart } from "./LineChart";
import { PieChart } from "./PieChart";
import { MultiseriesBarChart } from "./MultiseriesBarChart";
import { MultiseriesLineChart } from "./MultiseriesLineChart";

import { ChatChartProps } from "./types";

export const ChatChart: FC<ChatChartProps> = ({ chartData }) => {
  if (isNil(chartData)) {
    return null;
  }

  switch (chartData.type) {
    case "bar":
      return <BarChart chartData={chartData} />;
    case "line":
      return <LineChart chartData={chartData} />;
    case "pie":
      return <PieChart chartData={chartData} />;
    case "multiseries_bar":
      return <MultiseriesBarChart chartData={chartData} />;
    case "multiseries_line":
      return <MultiseriesLineChart chartData={chartData} />;
    default:
      return null;
  }
};
